<div class="mpc-board-team" [attr.data-team-id]="teamKey">
    <div class="row">
        <!-- First Cell in Row for Team -->
        <div class="cell cell--team">
            <div *ngIf="showHeader" class="cell--header">
                <div class="label">{{'actionview.mpc-board.team' | translate}}</div>
            </div>
            <div class="cell--content">
                <div class="label">{{teamKey}}</div>
                <a class="mpc-action" (click)="removeTeam()">
                    {{'actionview.mpc-board.remove-team' | translate}}
                </a>
            </div>
        </div>

        <!-- 2nd to X-th cell for sprints -->
        <div *ngFor="let sprint of sprints" class="cell cell--sprint">
            <div *ngIf="showHeader" class="cell--header">
                <div class="label label--sprint">{{sprint.name}}</div>
            </div>
            <div class="cell--content">
                <app-mpc-board-sprint 
                    [sprint]="sprint" 
                    [teamKey]="teamKey" 
                    [statuses]="statuses"
                    (loadingDataCompleted)="onSprintBoardIsReady($event)"
                    >

                </app-mpc-board-sprint>
            </div>
            <a *ngIf="sprint.state !== 'closed'" class="add-issue" (click)="openNewIssueDialog($event, sprint)">
                {{('actionview.taskboard.addIssue' | translate)}}
            </a>
        </div>
    </div>
</div>